import React from "react";
import { Typography, Link } from "@mui/material";
import { config } from "../config";

const ConfirmationEndMessage = () => {
  const sarsEfilingUrl = config.SARS_EFILING_URL;
  const digitalChannelsUrl = config.DIGITAL_CHANNELS_URL;

  return (
    <Typography>
      <br/>
      If you would like to update your details, please visit{" "}
      <Link href={sarsEfilingUrl} target="_blank" rel="noopener noreferrer">
        SARS eFiling
      </Link>{" "}
      or make use of our{" "}
      <Link href={digitalChannelsUrl} target="_blank" rel="noopener noreferrer">
        Digital Channels Platform
      </Link>
      . <br/><br/>Alternatively, you can contact us via WhatsApp on +27 80 011 7277.
    </Typography>
  );
};

export default ConfirmationEndMessage;
